import React, { useState, useEffect, useRef } from "react";
import { styled } from "@mui/material/styles";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import store from "../../store";
import { useSelector } from "react-redux";
import "./styles/_index.scss";
import mapboxgl from "mapbox-gl";
import * as turf from "@turf/turf";
import cyclone_0 from "./../../assets/vectos/cyclone_0.gif";
import cyclone_1 from "./../../assets/vectos/cyclone_1.gif";
import cyclone_2 from "./../../assets/vectos/cyclone_2.gif";
import cyclone_3 from "./../../assets/vectos/cyclone_3.gif";
import cyclone_4 from "./../../assets/vectos/cyclone_4.gif";
import cyclone_5 from "./../../assets/vectos/cyclone_5.gif";
import cyclone_0_g from "./../../assets/vectos/cyclone_0_g.png";
import cyclone_1_g from "./../../assets/vectos/cyclone_1_g.png";
import cyclone_2_g from "./../../assets/vectos/cyclone_2_g.png";
import cyclone_3_g from "./../../assets/vectos/cyclone_3_g.png";
import cyclone_4_g from "./../../assets/vectos/cyclone_4_g.png";
import cyclone_5_g from "./../../assets/vectos/cyclone_5_g.png";
import cyclone_0_new from "../../assets/vectos/cyclone_0_R.gif";
import cyclone_1_new from "../../assets/vectos/cyclone_1_R.gif";
import cyclone_2_new from "../../assets/vectos/cyclone_2_R.gif";
import cyclone_3_new from "../../assets/vectos/cyclone_3_R.gif";
import cyclone_4_new from "../../assets/vectos/cyclone_4_R.gif";
import cyclone_5_new from "../../assets/vectos/cyclone_5_R.gif";
import axios from "axios";
import { CircularProgress, Button } from "@mui/material";
import Loder from "../../components/loader/index";

mapboxgl.accessToken =
  "pk.eyJ1IjoiZHNkYXNhIiwiYSI6ImNsemp4d2JkMzByeHkycXF5cWhuc2sybGUifQ.Dag-kzM-Lw7VcHNz4XGeSg";

const drawerWidth = 0;

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const typhon_icon: any = {
  0: cyclone_0,
  1: cyclone_1,
  2: cyclone_2,
  3: cyclone_3,
  4: cyclone_4,
  5: cyclone_5,
};

const typhon_icon_g: any = {
  0: cyclone_0_g,
  1: cyclone_1_g,
  2: cyclone_2_g,
  3: cyclone_3_g,
  4: cyclone_4_g,
  5: cyclone_5_g,
};

const typhon_icon_new: any = {
  0: cyclone_0_new,
  1: cyclone_1_new,
  2: cyclone_2_new,
  3: cyclone_3_new,
  4: cyclone_4_new,
  5: cyclone_5_new,
};

interface IUserGeoCoords {
  lat: string;
  lng: string;
}

export default function TyphoonComponent() {
  const data = useSelector((state: any) => state?.app);
  const [sn, setSn] = useState(localStorage.getItem("sideNav"));
  const windowWidth = useRef(window.innerWidth);
  const [open, setOpen] = useState(windowWidth.current > 1000 ? true : false);
  const [warningData, setWarningData] = useState({});
  const [loading, setLoading] = useState<{ [key: string]: boolean }>({});
  const [fetchedDatas, setFetchedDatas] = useState<any>(null);
  const [stormDatas, setStormDatas] = useState<any>([]);
  const [trackDatas, setTrackDatas] = useState<any>([]);
  const [mapHovers, setMapHovers] = useState<any>([]);
  const [TyphonCoords, setTyphonCoords] = useState<any>([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [mapDataLoaded, setMapDataLoaded] = useState(false);
  const [apiError, setApiError] = useState<string | null>(null);
  const [userGeoCords, setuserGeoCords] = useState<IUserGeoCoords>({
    lat: "1.290270",
    lng: "103.851959",
  });
  const [isStyleLoaded, setIsStyleLoaded] = useState(false);
  const [zoom, setZoom] = useState<number>(4);
  const [activeRadius, setActiveRadius] = useState<string[]>([
    "kts_34_ne",
    "kts_50_ne",
    "kts_64_ne",
    "kts_80_ne",
  ]);
  const [btncolor, setBtnColor] = useState<any>({ background: "white" });
  const [pdfAvailability, setPdfAvailability] = useState<{
    [key: string]: boolean;
  }>({});
  const [showGrid, setShowGrid] = useState(true);
  const [hoverCoords, setHoverCoords] = useState<{
    lat: number;
    lng: number;
  } | null>(null);

  const getQuadrantKey = (
    stormLat: number,
    stormLon: number,
    projectLat: number,
    projectLon: number,
  ): string => {
    const isNorth = stormLat >= projectLat;
    const isEast = stormLon >= projectLon;
    if (isNorth && isEast) return "ne";
    else if (!isNorth && isEast) return "se";
    else if (!isNorth && !isEast) return "sw";
    else return "nw";
  };

  const mapContainer = useRef<HTMLDivElement | null>(null);
  const map = useRef<mapboxgl.Map | null>(null);
  const popupbar = useRef(null);
  const markersRef = useRef<mapboxgl.Marker[]>([]);
  const layersRef = useRef<string[]>([]);
  const sourcesRef = useRef<string[]>([]);
  const zoomTimeoutRef = useRef<NodeJS.Timeout>();

  const userCircleRadius = [
    "warning_radius1_frequency",
    "warning_radius2_frequency",
    "warning_radius3_frequency",
  ];

  const userCircleColors: any = {
    warning_radius1_frequency: "green",
    warning_radius2_frequency: "yellow",
    warning_radius3_frequency: "red",
  };

  const circleRadius = ["kts_34_ne", "kts_50_ne", "kts_64_ne", "kts_80_ne"];

  const circleColors: any = {
    kts_34_ne: "green",
    kts_50_ne: "yellow",
    kts_64_ne: "red",
    kts_80_ne: "black",
  };

  function calculateCardinalDirection(
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number,
  ): number {
    const toRadians = (degrees: number) => degrees * (Math.PI / 180);
    const toDegrees = (radians: number) => radians * (180 / Math.PI);
    const dLonRad = toRadians(lon2 - lon1);
    const lat1Rad = toRadians(lat1);
    const lat2Rad = toRadians(lat2);
    const y = Math.sin(dLonRad) * Math.cos(lat2Rad);
    const x =
      Math.cos(lat1Rad) * Math.sin(lat2Rad) -
      Math.sin(lat1Rad) * Math.cos(lat2Rad) * Math.cos(dLonRad);
    let bearing = toDegrees(Math.atan2(y, x));
    bearing = (bearing + 360) % 360;
    return bearing;
  }

  function addDirectionsToStormTrack(stormData: any[]) {
    if (!Array.isArray(stormData) || stormData.length < 2) {
      return stormData;
    }

    const processedData = stormData.map((point) => ({ ...point }));

    const chronologicalData = [...processedData].sort((a, b) => {
      const dateA = new Date(a.date_utc);
      const dateB = new Date(b.date_utc);
      return dateA.getTime() - dateB.getTime();
    });

    for (let i = 0; i < chronologicalData.length - 1; i++) {
      const fromPoint = chronologicalData[i];
      const toPoint = chronologicalData[i + 1];
      const bearing = calculateCardinalDirection(
        fromPoint.lat,
        fromPoint.lon,
        toPoint.lat,
        toPoint.lon,
      );

      const direction = coronical(bearing);

      const originalFromIndex = processedData.findIndex(
        (p) =>
          p.date_utc === fromPoint.date_utc &&
          p.lat === fromPoint.lat &&
          p.lon === fromPoint.lon &&
          p.storm_path_data_id === fromPoint.storm_path_data_id,
      );

      if (originalFromIndex !== -1) {
        processedData[originalFromIndex].direction = direction;
        processedData[originalFromIndex].bearing = Math.round(bearing);
        processedData[originalFromIndex].calculatedHeading = bearing;
      }

      const originalToIndex = processedData.findIndex(
        (p) =>
          p.date_utc === toPoint.date_utc &&
          p.lat === toPoint.lat &&
          p.lon === toPoint.lon &&
          p.storm_path_data_id === toPoint.storm_path_data_id,
      );

      if (originalToIndex !== -1) {
        processedData[originalToIndex].direction = direction;
        processedData[originalToIndex].bearing = Math.round(bearing);
        processedData[originalToIndex].calculatedHeading = bearing;
      }
    }

    return processedData;
  }

  function generateGridGeoJSON(
    zoom: number,
  ): GeoJSON.FeatureCollection<GeoJSON.LineString> {
    const features: GeoJSON.Feature<GeoJSON.LineString>[] = [];

    let step: number;
    if (zoom <= 1) {
      step = 30;
    } else if (zoom <= 2) {
      step = 15;
    } else if (zoom <= 3) {
      step = 10;
    } else if (zoom <= 4) {
      step = 5;
    } else if (zoom <= 5) {
      step = 2;
    } else if (zoom <= 6) {
      step = 1;
    } else if (zoom <= 7) {
      step = 0.5;
    } else if (zoom <= 8) {
      step = 0.25;
    } else if (zoom <= 10) {
      step = 0.1;
    } else if (zoom <= 12) {
      step = 0.05;
    } else if (zoom <= 14) {
      step = 0.025;
    } else if (zoom <= 16) {
      step = 0.01;
    } else {
      step = 0.005;
    }

    for (let lat = -90; lat <= 90; lat += step) {
      const clampedLat = Math.max(-90, Math.min(90, lat));

      features.push({
        type: "Feature",
        geometry: {
          type: "LineString",
          coordinates: [
            [-180, clampedLat],
            [180, clampedLat],
          ],
        },
        properties: {
          gridType: "parallel",
          latitude: clampedLat,
          step: step,
        },
      });
    }

    for (let lon = -180; lon <= 180; lon += step) {
      const clampedLon = Math.max(-180, Math.min(180, lon));

      features.push({
        type: "Feature",
        geometry: {
          type: "LineString",
          coordinates: [
            [clampedLon, -90],
            [clampedLon, 90],
          ],
        },
        properties: {
          gridType: "meridian",
          longitude: clampedLon,
          step: step,
        },
      });
    }

    return {
      type: "FeatureCollection",
      features,
    };
  }

  function addGridToMap(showGrid: boolean = true) {
    if (!map.current) return;

    const gridSourceId = "grid-source";
    const gridLayerId = "grid-layer";

    try {
      if (map.current.getLayer(gridLayerId)) {
        map.current.removeLayer(gridLayerId);
      }
      if (map.current.getSource(gridSourceId)) {
        map.current.removeSource(gridSourceId);
      }

      layersRef.current = layersRef.current.filter((id) => id !== gridLayerId);
      sourcesRef.current = sourcesRef.current.filter(
        (id) => id !== gridSourceId,
      );

      if (showGrid) {
        const currentZoom = map.current.getZoom();

        const gridData = generateGridGeoJSON(currentZoom);

        map.current.addSource(gridSourceId, {
          type: "geojson",
          data: gridData,
        });

        map.current.addLayer({
          id: gridLayerId,
          type: "line",
          source: gridSourceId,
          paint: {
            "line-color": "#666666",
            "line-width": 0.5,
            "line-opacity": 0.6,
          },
          layout: {
            "line-cap": "round",
            "line-join": "round",
          },
        });

        map.current.setPaintProperty(gridLayerId, "line-dasharray", [2, 2]);

        layersRef.current.push(gridLayerId);
        sourcesRef.current.push(gridSourceId);
      }
    } catch (error) {
      console.warn("Error updating grid:", error);
    }
  }

  useEffect(() => {
    const l = localStorage.getItem("sideNav");
    setSn(l);
  }, []);

  useEffect(() => {
    store.dispatch({
      type: "TOGGLE_MENU",
      payload: windowWidth.current > 1000 ? true : false,
    });
  }, []);

  useEffect(() => {
    setOpen(data.toggle);
  }, [data]);

  useEffect(() => {
    if (!map.current) return;

    const handleZoom = () => {
      clearTimeout(zoomTimeoutRef.current);
      zoomTimeoutRef.current = setTimeout(() => {
        addGridToMap(true);
      }, 200);
    };

    map.current.on("zoom", handleZoom);

    return () => {
      if (map.current) {
        map.current.off("zoom", handleZoom);
      }
    };
  }, []);
  useEffect(() => {
    if (!map.current || !isStyleLoaded || !mapDataLoaded) return;

    const handleMouseMove = (e: mapboxgl.MapMouseEvent) => {
      const { lng, lat } = e.lngLat;
      setHoverCoords({ lat, lng });
    };

    const handleMouseLeave = () => {
      setHoverCoords(null);
    };

    // Remove existing listeners first
    map.current.off("mousemove", handleMouseMove);
    map.current.off("mouseout", handleMouseLeave);

    // Add new listeners
    map.current.on("mousemove", handleMouseMove);
    map.current.on("mouseout", handleMouseLeave);

    return () => {
      if (map.current) {
        map.current.off("mousemove", handleMouseMove);
        map.current.off("mouseout", handleMouseLeave);
      }
    };
  }, [isStyleLoaded, mapDataLoaded]);

  const calculateDistanceNauticalMiles = (
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number,
  ): number => {
    if (lat1 === lat2 && lon1 === lon2) {
      return 0;
    }
    const lat1Rad = (lat1 * Math.PI) / 180;
    const lat2Rad = (lat2 * Math.PI) / 180;
    const dLonRad = ((lon2 - lon1) * Math.PI) / 180;
    const distanceNauticalMiles =
      60 *
      (180 / Math.PI) *
      Math.acos(
        Math.sin(lat1Rad) * Math.sin(lat2Rad) +
          Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.cos(dLonRad),
      );
    return distanceNauticalMiles;
  };

  function coronical(data: number): string {
    data = data % 360;
    if (data < 0) data += 360;
    const directions = [
      "N",
      "NNE",
      "NE",
      "ENE",
      "E",
      "ESE",
      "SE",
      "SSE",
      "S",
      "SSW",
      "SW",
      "WSW",
      "W",
      "WNW",
      "NW",
      "NNW",
    ];
    let closestIndex = Math.round(data / 22.5) % 16;
    return directions[closestIndex];
  }
  function calculateEllipse(
    latCenter: number,
    lonCenter: number,
    semiMajorNm: number,
    semiMinorNm: number,
    rotationDeg: number = 0,
  ): GeoJSON.Feature<GeoJSON.Polygon> {
    const lat_radius_deg = semiMajorNm / 60;
    const lon_radius_deg =
      semiMajorNm / (60 * Math.cos((latCenter * Math.PI) / 180));

    const coordinates: [number, number][] = [];

    for (let i = 0; i < 100; i++) {
      const theta = (i / 99) * 2 * Math.PI;

      const lat_ellipse = latCenter + lat_radius_deg * Math.sin(theta);

      const lon_ellipse = lonCenter + lon_radius_deg * Math.cos(theta);

      coordinates.push([lon_ellipse, lat_ellipse]);
    }

    coordinates.push(coordinates[0]);

    return turf.polygon([coordinates]);
  }

  function calculateMultipleEllipses(
    latCenter: number,
    lonCenter: number,
    semiMajorRadiiNm: number[],
    semiMinorRadiiNm: number[],
    rotationDeg: number = 0,
  ): GeoJSON.FeatureCollection<GeoJSON.Polygon> {
    const features = semiMajorRadiiNm.map((radius_nm, index) => {
      return calculateEllipse(
        latCenter,
        lonCenter,
        radius_nm,
        radius_nm,
        rotationDeg,
      );
    });

    return {
      type: "FeatureCollection",
      features: features,
    };
  }

  function calculateCenterPoint(
    latCenter: number,
    lonCenter: number,
  ): GeoJSON.Feature<GeoJSON.Point> {
    return {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [lonCenter, latCenter],
      },
      properties: {
        label: "Center Point",
      },
    };
  }

  function generateEllipticalRegions(
    latCenter: number,
    lonCenter: number,
    semiMajorRadiiNm: number[],
    semiMinorRadiiNm: number[],
    colors: string[],
    rotationDeg: number = 0,
  ): {
    ellipses: GeoJSON.FeatureCollection<GeoJSON.Polygon>;
    centerPoint: GeoJSON.Feature<GeoJSON.Point>;
    metadata: {
      latCenter: number;
      lonCenter: number;
      semiMajorRadiiNm: number[];
      semiMinorRadiiNm: number[];
      colors: string[];
      rotationDeg: number;
    };
  } {
    semiMajorRadiiNm.forEach((radius_nm) => {
      const lat_radius_deg = radius_nm / 60;
      const lon_radius_deg = radius_nm / 60;

      const area_deg2 = Math.PI * lat_radius_deg * lon_radius_deg;
      const area_km2 = area_deg2 * 111.32 ** 2;
    });

    const ellipses = calculateMultipleEllipses(
      latCenter,
      lonCenter,
      semiMajorRadiiNm,
      semiMinorRadiiNm,
      rotationDeg,
    );

    ellipses.features.forEach((feature, index) => {
      feature.properties = {
        semiMajorRadius: semiMajorRadiiNm[index] || 0,
        semiMinorRadius: semiMajorRadiiNm[index] || 0,
        color: colors[index] || "blue",
        label: `${semiMajorRadiiNm[index] || 0} NM Circle`,
      };
    });

    const centerPoint = calculateCenterPoint(latCenter, lonCenter);

    return {
      ellipses,
      centerPoint,
      metadata: {
        latCenter,
        lonCenter,
        semiMajorRadiiNm,
        semiMinorRadiiNm: semiMajorRadiiNm,
        colors,
        rotationDeg,
      },
    };
  }

  // function returnCycloneRange(value: number) {
  //   if (value < 64) {
  //     return 0;
  //   } else if (value >= 64 && value <= 82) {
  //     return 1;
  //   } else if (value >= 83 && value <= 95) {
  //     return 2;
  //   } else if (value >= 96 && value <= 112) {
  //     return 3;
  //   } else if (value >= 113 && value < 136) {
  //     return 4;
  //   } else if (value >= 157) {
  //     return 5;
  //   } else {
  //     return 0;
  //   }
  // }
  function returnCycloneRange(value: number) {
    if (value < 64) {
      return 0;
    } else if (value >= 64 && value <= 82) {
      return 1;
    } else if (value >= 83 && value <= 95) {
      return 2;
    } else if (value >= 96 && value <= 112) {
      return 3;
    } else if (value >= 113 && value <= 136) {
      return 4;
    } else if (value >= 137) {
      return 5;
    } else {
      return 0;
    }
  }
  const cleanupMapFeatures = () => {
    if (!map.current) return;

    try {
      markersRef.current.forEach((marker) => {
        try {
          marker.remove();
        } catch (error) {
          console.warn("Error removing marker:", error);
        }
      });
      markersRef.current = [];

      [...layersRef.current].reverse().forEach((layerId) => {
        try {
          if (map.current?.getLayer(layerId)) {
            map.current.removeLayer(layerId);
          }
        } catch (error) {
          console.warn("Error removing layer:", layerId, error);
        }
      });
      layersRef.current = [];

      sourcesRef.current.forEach((sourceId) => {
        try {
          if (map.current?.getSource(sourceId)) {
            map.current.removeSource(sourceId);
          }
        } catch (error) {
          console.warn("Error removing source:", sourceId, error);
        }
      });
      sourcesRef.current = [];
    } catch (error) {
      console.warn("Error during cleanup:", error);
    }
  };

  const showClicle = () => {
    if (map.current && activeRadius) {
      circleRadius.forEach((radius, rIndex) => {
        TyphonCoords.forEach((datas: any, main_index: number) => {
          if (Array.isArray(datas)) {
            datas.forEach((data: any, index: number) => {
              const layerId = `circle-fill-${main_index}-${index}-${rIndex}`;
              try {
                if (map.current!.getLayer(layerId)) {
                  const visibility = activeRadius.includes(radius)
                    ? "visible"
                    : "none";
                  map.current!.setLayoutProperty(
                    layerId,
                    "visibility",
                    visibility,
                  );
                }
              } catch (error) {
                console.warn(`Error toggling layer ${layerId}:`, error);
              }
            });
          }
        });
      });
    }
  };

  useEffect(() => {
    if (!map.current) return;
    showClicle();
  }, [activeRadius]);

  useEffect(() => {
    const fetchStormData = async () => {
      setDataLoaded(false);
      setApiError(null);

      try {
        const response_storm = await axios.get(
          `${process.env.REACT_APP_BACKEND_IP}/api/stormdatas/`,
        );
        if (!response_storm.data) {
          throw new Error("Failed to fetch storm data");
        }
        const data_storm = response_storm.data;
        const stormDatasArray = Array.isArray(data_storm.storm_datas)
          ? data_storm.storm_datas
          : [];
        const trackDatasArray = Array.isArray(data_storm.track_datas)
          ? data_storm.track_datas
          : [];
        const mapHoversData = data_storm.map_hovers || {};
        setStormDatas(stormDatasArray);
        setTrackDatas(trackDatasArray);
        setMapHovers(mapHoversData);

        const processedTyphonCoords = stormDatasArray.map((datas: any) => {
          if (!Array.isArray(datas)) {
            return [];
          }

          const validData = datas
            .map((data: any) => {
              if (
                !data ||
                typeof data.lat !== "number" ||
                typeof data.lon !== "number"
              ) {
                console.warn("Invalid coordinate data:", data);
                return null;
              }

              let formattedDate = "-";
              if (data.date_utc) {
                try {
                  const utcDate = new Date(data.date_utc + "Z");
                  const day = utcDate.getUTCDate().toString().padStart(2, "0");
                  const time = `${utcDate
                    .getUTCHours()
                    .toString()
                    .padStart(2, "0")}:${utcDate
                    .getUTCMinutes()
                    .toString()
                    .padStart(2, "0")}`;
                  formattedDate = `${day}/${time}`;
                } catch (dateError) {
                  console.warn("Invalid date:", data.date_utc);
                }
              }

              return {
                ...data,
                latlng: [data.lon, data.lat],
                info: `Time UTC: ${formattedDate}`,
              };
            })
            .filter((item) => item !== null);

          return addDirectionsToStormTrack(validData);
        });

        setTyphonCoords(processedTyphonCoords);
        setDataLoaded(true);
      } catch (error) {
        console.error("Error fetching storm data:", error);
        setApiError(
          error instanceof Error ? error.message : "Failed to fetch storm data",
        );

        setStormDatas([]);
        setTrackDatas([]);
        setMapHovers({});
        setTyphonCoords([]);
        setDataLoaded(true);
      }
    };
    fetchStormData();
  }, []);

  useEffect(() => {
    const renderMap = async () => {
      if (!mapContainer.current) {
        return;
      }
      setMapDataLoaded(false);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_IP}/api/cyclone/${localStorage.getItem("fid")}/`,
        );
        const data = response.data;
        if (
          !data.project_location ||
          typeof data.project_location.latitude !== "number" ||
          typeof data.project_location.longitude !== "number"
        ) {
          throw new Error("Invalid or missing project location coordinates");
        }

        const newUserCoords = {
          lat: data.project_location.latitude.toString(),
          lng: data.project_location.longitude.toString(),
        };
        setuserGeoCords(newUserCoords);
        setFetchedDatas(data);
        setWarningData(data.cyclone_data || {});
        if (map.current) {
          map.current.remove();
          map.current = null;
        }
        const unitId = data.cyclone_data?.warning_radius_unit_id;
        const toNm = (val: number) => (unitId === 16 ? val / 1.852 : val);
        const unitLabel = unitId === 16 ? "km" : "nm";

        map.current = new mapboxgl.Map({
          container: mapContainer.current,
          style: "mapbox://styles/mapbox/light-v10",
          center: [
            data.project_location.longitude,
            data.project_location.latitude,
          ],
          zoom: zoom,
          minZoom: 1.5,
          projection: {
            name: "equirectangular",
          },
        });

        map.current.on("load", () => {
          setIsStyleLoaded(true);

          const initialGridGeoJSON = generateGridGeoJSON(zoom);
          map.current!.addSource("grid-source", {
            type: "geojson",
            data: initialGridGeoJSON,
          });
          sourcesRef.current.push("grid-source");

          map.current!.addLayer({
            id: "grid-layer",
            type: "line",
            source: "grid-source",
            paint: {
              "line-color": "#000000",
              "line-width": 1,
              "line-dasharray": [2, 2],
              "line-opacity": 0.5,
            },
            layout: {
              "line-cap": "round",
              "line-join": "round",
            },
          });
          map.current!.setPaintProperty("grid-layer", "line-dasharray", [2, 2]);
          layersRef.current.push("grid-layer");

          map.current!.on("zoomend", () => {
            const currentZoom = map.current!.getZoom();
            setZoom(currentZoom);
            const updatedGridGeoJSON = generateGridGeoJSON(currentZoom);
            (
              map.current!.getSource("grid-source") as mapboxgl.GeoJSONSource
            ).setData(updatedGridGeoJSON);
          });
        });

        map.current.on("load", () => {
          map.current!.on("click", () => {
            const existingPopups = document.querySelectorAll(".mapboxgl-popup");
            existingPopups.forEach((popup) => {
              if (!popup.classList.contains("project-label-popup")) {
                popup.remove();
              }
            });
          });
        });

        map.current.addControl(
          new mapboxgl.NavigationControl({ showCompass: false }),
          "top-right",
        );
        map.current.addControl(new mapboxgl.FullscreenControl());
        setMapDataLoaded(true);
      } catch (error) {
        console.error("Error initializing map:", error);
        setApiError(
          error instanceof Error ? error.message : "Failed to initialize map",
        );
        setuserGeoCords({ lat: "1.290270", lng: "103.851959" });
        setFetchedDatas(null);
        setMapDataLoaded(true);
      }
    };

    renderMap();
  }, []);

  const isCurrentOrFutureDate = (dateUtc: string) => {
    if (!dateUtc) return false;

    try {
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);

      const stormDate = new Date(dateUtc + "Z");
      stormDate.setHours(0, 0, 0, 0);

      return stormDate >= currentDate;
    } catch (error) {
      console.warn("Invalid date:", dateUtc);
      return false;
    }
  };

  useEffect(() => {
    if (
      !isStyleLoaded ||
      !map.current ||
      !mapContainer.current ||
      !mapDataLoaded ||
      !dataLoaded ||
      !fetchedDatas
    ) {
      return;
    }
    const timeoutId = setTimeout(() => {
      if (!map.current || !isStyleLoaded) {
        return;
      }

      try {
        if (
          userGeoCords.lng &&
          userGeoCords.lat &&
          fetchedDatas?.cyclone_data
        ) {
          const currentUserLat = parseFloat(userGeoCords.lat);
          const currentUserLng = parseFloat(userGeoCords.lng);
          const unitId = fetchedDatas?.cyclone_data?.warning_radius_unit_id;
          const toNm = (val: number) => (unitId === 16 ? val / 1.852 : val);
          const unitLabel = unitId === 16 ? "km" : "nm";

          const userRadiiRaw = userCircleRadius
            .map((radius) => fetchedDatas?.cyclone_data?.[radius])
            .filter((r) => r !== undefined && r > 0);

          const userRadii = userRadiiRaw.map(toNm);
          const userColors = userCircleRadius.map(
            (radius) => userCircleColors[radius],
          );
          const semiMinorRadii = userRadii.map((radius) => radius * 0.7);
          const rotationDeg = 0;
          if (userRadii.length > 0) {
            const ellipticalRegions = generateEllipticalRegions(
              currentUserLat,
              currentUserLng,
              userRadii,
              semiMinorRadii,
              userColors,
              rotationDeg,
            );

            ellipticalRegions.ellipses.features.forEach((feature, index) => {
              if (feature.properties) {
                feature.properties.label = `${userRadiiRaw[index] || 0}`;
                feature.properties.semiMajorRadius = userRadiiRaw[index] || 0;
              }
            });

            ellipticalRegions.ellipses.features.forEach(
              (ellipseFeature, rIndex) => {
                if (map.current && ellipseFeature.properties) {
                  const sourceId = `ellipseData-${rIndex}`;
                  const strokeLayerId = `ellipse-stroke-${rIndex}`;

                  if (!map.current.getSource(sourceId)) {
                    map.current.addSource(sourceId, {
                      type: "geojson",
                      data: ellipseFeature,
                    });
                    sourcesRef.current.push(sourceId);
                  }

                  if (!map.current.getLayer(strokeLayerId)) {
                    map.current.addLayer({
                      id: strokeLayerId,
                      type: "line",
                      source: sourceId,
                      paint: {
                        "line-color": ellipseFeature.properties.color || "blue",
                        "line-width": 2,
                      },
                    });
                    layersRef.current.push(strokeLayerId);
                  }

                  const labelCoordinates =
                    ellipseFeature.geometry.coordinates[0][50];
                  const labelGeoJson: GeoJSON.FeatureCollection<GeoJSON.Geometry> =
                    {
                      type: "FeatureCollection",
                      features: [
                        {
                          type: "Feature",
                          geometry: {
                            type: "Point",
                            coordinates: labelCoordinates as [number, number],
                          },
                          properties: {
                            label:
                              ellipseFeature.properties?.semiMajorRadius?.toString() ||
                              "0",
                          },
                        },
                      ],
                    };

                  const labelSourceId = `labelData-${rIndex}`;
                  const labelLayerIdText = `labelLayer-${rIndex}`;

                  if (!map.current.getSource(labelSourceId)) {
                    map.current.addSource(labelSourceId, {
                      type: "geojson",
                      data: labelGeoJson,
                    });
                    sourcesRef.current.push(labelSourceId);
                  }

                  if (!map.current.getLayer(labelLayerIdText)) {
                    map.current.addLayer({
                      id: labelLayerIdText,
                      type: "symbol",
                      source: labelSourceId,
                      layout: {
                        "text-field": `{label}${unitLabel}`,
                        "text-size": [
                          "interpolate",
                          ["linear"],
                          ["zoom"],
                          5,
                          10,
                          10,
                          24,
                        ],
                        "text-offset": [0, 2.5],
                        "text-anchor": "bottom",
                        "text-justify": "center",
                      },
                      paint: {
                        "text-color": "#000000",
                      },
                    });
                    layersRef.current.push(labelLayerIdText);
                  }
                }
              },
            );
          }
        }

        if (Array.isArray(stormDatas) && stormDatas.length > 0) {
          stormDatas.forEach((datas: any) => {
            if (Array.isArray(datas)) {
              datas.forEach((data: any) => {
                if (
                  data &&
                  typeof data.lat === "number" &&
                  typeof data.lon === "number" &&
                  data.storm_category_id === 54
                ) {
                  const marker = new mapboxgl.Marker()
                    .setLngLat([parseFloat(data.lon), parseFloat(data.lat)])
                    .addTo(map.current!);
                  markersRef.current.push(marker);
                  let project = localStorage.getItem("project");
                  let trimmedProject = project
                    ? project.match(/^(.*?)(?=-\d+)/)?.[0].trim() || ""
                    : "";
                  const popup = new mapboxgl.Popup({
                    offset: 35,
                    closeButton: false,
                    closeOnClick: false,
                  })
                    .setHTML(`<b>${trimmedProject}</b>`)
                    .setLngLat([parseFloat(data.lon), parseFloat(data.lat)])
                    .addTo(map.current!);
                }
              });
            }
          });
        }

        if (Array.isArray(TyphonCoords) && TyphonCoords.length > 0) {
          TyphonCoords.forEach((main_datas: any, main_index: number) => {
            if (!Array.isArray(main_datas) || main_datas.length === 0) {
              console.warn(
                `Invalid main_datas at index ${main_index}:`,
                main_datas,
              );
              return;
            }

            const labelGeoJSON = {
              type: "FeatureCollection",
              features: main_datas.map((item: any, index: number) => ({
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: item.latlng,
                },
                properties: {
                  title: main_datas.length - index,
                },
              })),
            };

            const textLayerId = `text-layer-${main_index}`;
            if (map.current && !map.current.getLayer(textLayerId)) {
              map.current.addLayer({
                id: textLayerId,
                type: "symbol",
                source: {
                  type: "geojson",
                  data: labelGeoJSON,
                } as any,
                layout: {
                  "text-field": "{title}",
                  "text-offset": [0, 2],
                  "text-anchor": "right",
                  "text-font": ["Open Sans Bold", "Arial Unicode MS Bold"],
                  "text-size": [
                    "interpolate",
                    ["linear"],
                    ["zoom"],
                    5,
                    10,
                    10,
                    15,
                    15,
                    20,
                  ],
                },
              });
              layersRef.current.push(textLayerId);
            }

            for (let i = 0; i < main_datas.length - 1; i++) {
              const currentPoint = main_datas[i];
              const nextPoint = main_datas[i + 1];

              if (!currentPoint?.latlng || !nextPoint?.latlng) continue;

              const segmentColor = isCurrentOrFutureDate(nextPoint.date_utc)
                ? "#000000"
                : "#808080";

              const segmentGeoJSON = {
                type: "Feature",
                geometry: {
                  type: "LineString",
                  coordinates: [currentPoint.latlng, nextPoint.latlng],
                },
                properties: {},
              } as any;

              const segmentSourceId = `line-segment-source-${main_index}-${i}`;
              const segmentLayerId = `line-segment-${main_index}-${i}`;

              if (map.current && !map.current.getLayer(segmentLayerId)) {
                map.current.addSource(segmentSourceId, {
                  type: "geojson",
                  data: segmentGeoJSON,
                });
                sourcesRef.current.push(segmentSourceId);

                map.current.addLayer({
                  id: segmentLayerId,
                  type: "line",
                  source: segmentSourceId,
                  layout: {
                    "line-join": "round",
                    "line-cap": "round",
                  },
                  paint: {
                    "line-color": segmentColor,
                    "line-width": 2,
                  },
                });
                layersRef.current.push(segmentLayerId);
              }
            }

            const reversedData = [...main_datas].reverse();
            reversedData.forEach((item: any, index: number) => {
              if (
                !item ||
                !item.latlng ||
                !Array.isArray(item.latlng) ||
                item.latlng.length !== 2
              ) {
                console.warn("Invalid item data:", item);
                return;
              }

              const markerElement = document.createElement("div");
              markerElement.style.width = "30px";
              markerElement.style.height = "30px";
              markerElement.style.cursor = "pointer";
              markerElement.style.backgroundSize = "contain";
              markerElement.style.backgroundRepeat = "no-repeat";
              markerElement.style.backgroundPosition = "center";

              const userDistance = calculateDistanceNauticalMiles(
                parseFloat(userGeoCords.lat),
                parseFloat(userGeoCords.lng),
                parseFloat(item.latlng[1]),
                parseFloat(item.latlng[0]),
              );

              const cyclone_range_icon = returnCycloneRange(
                item.speed_kts !== undefined && item.distance !== undefined
                  ? 0
                  : item.max_wind_speed !== undefined
                    ? item.max_wind_speed
                    : item.speed_kts || 0,
              );

              const latValue = parseFloat(item.latlng[1]);
              const iconSet = latValue >= 0 ? typhon_icon_new : typhon_icon;

              const iconSrc =
                new Date(item.date_utc).toLocaleDateString() ===
                  new Date().toLocaleDateString() ||
                new Date(item.date_utc) >= new Date()
                  ? iconSet[cyclone_range_icon]
                  : typhon_icon_g[cyclone_range_icon];

              markerElement.style.backgroundImage = `url(${iconSrc})`;
              markerElement.style.transform = `rotate(${
                latValue >= 0 ? "-90deg" : "90deg"
              })`;

              if (map.current) {
                const marker = new mapboxgl.Marker({
                  element: markerElement,
                })
                  .setLngLat(item.latlng)
                  .addTo(map.current);

                const createPopupContent = () => {
                  const formatDirectionWithSpeed = (
                    direction: string | null,
                    speed: number | undefined,
                  ) => {
                    if (!direction || speed === undefined) return "-";
                    const formattedSpeed = Math.floor(speed)
                      .toString()
                      .padStart(3, "0");
                    return `${direction} / ${formattedSpeed} kn`;
                  };

                  const directionDisplay = formatDirectionWithSpeed(
                    item.direction,
                    item.speed_kts,
                  );

                  return `
                    <center>
                      ${item.info || "No time info"}<br> Distance:
                      ${userDistance.toFixed(0)} nm<br>
                      ${
                        item.max_wind_speed !== undefined
                          ? `Wind Speed: ${item.max_wind_speed} kn<br>`
                          : ""
                      }
                      ${
                        directionDisplay !== "-"
                          ? `Direction: ${directionDisplay}<br>`
                          : ""
                      }
                      Central Pressure: ${item.central_pressure || "-"} hPa<br>
                    </center>`;
                };

                let hoverPopup: mapboxgl.Popup | null = null;
                let clickPopup: mapboxgl.Popup | null = null;

                markerElement.onmouseenter = (e) => {
                  e.stopPropagation();
                  markerElement.style.opacity = "0.8";

                  if (!clickPopup) {
                    hoverPopup = new mapboxgl.Popup({
                      offset: 10,
                      closeButton: false,
                      closeOnClick: false,
                      anchor: "bottom",
                      className: "hover-popup",
                    })
                      .setHTML(createPopupContent())
                      .setLngLat(item.latlng)
                      .addTo(map.current!);
                  }
                };

                markerElement.onmouseleave = (e) => {
                  e.stopPropagation();
                  markerElement.style.opacity = "1";

                  if (hoverPopup && !clickPopup) {
                    hoverPopup.remove();
                    hoverPopup = null;
                  }
                };

                markerElement.onclick = (e) => {
                  e.stopPropagation();
                  e.preventDefault();

                  const existingClickPopups = document.querySelectorAll(
                    ".click-popup .mapboxgl-popup-content",
                  );
                  existingClickPopups.forEach((popup) => {
                    const popupElement = popup.closest(".mapboxgl-popup");
                    if (popupElement) {
                      popupElement.remove();
                    }
                  });

                  if (hoverPopup) {
                    hoverPopup.remove();
                    hoverPopup = null;
                  }

                  clickPopup = new mapboxgl.Popup({
                    offset: 10,
                    closeButton: true,
                    closeOnClick: false,
                    anchor: "bottom",
                    className: "click-popup",
                  })
                    .setHTML(createPopupContent())
                    .setLngLat(item.latlng)
                    .addTo(map.current!);

                  clickPopup.on("close", () => {
                    clickPopup = null;
                  });
                };

                markersRef.current.push(marker);

                circleRadius.forEach((radius, rIndex) => {
                  if (map.current) {
                    const sourceId = `circleData-${main_index}-${index}-${rIndex}`;
                    if (map.current.getSource(sourceId)) {
                      map.current.removeSource(sourceId);
                    }

                    const stormLat = item.latlng[1];
                    const stormLon = item.latlng[0];
                    const projectLat = parseFloat(userGeoCords.lat);
                    const projectLon = parseFloat(userGeoCords.lng);

                    const qk = getQuadrantKey(
                      stormLat,
                      stormLon,
                      projectLat,
                      projectLon,
                    );

                    const radiusKey = radius.replace("_ne", `_${qk}`);
                    const radiusValue = item[radiusKey] || 0;

                    if (radiusValue === 0) return;

                    const center = turf.point([stormLon, stormLat]);
                    const options = {
                      steps: 80,
                      units: "nauticalmiles" as "nauticalmiles",
                    };
                    const circle = turf.circle(center, radiusValue, options);

                    map.current.addSource(sourceId, {
                      type: "geojson",
                      data: circle,
                    });
                    sourcesRef.current.push(sourceId);

                    const layerId = `circle-fill-${main_index}-${index}-${rIndex}`;
                    map.current.addLayer({
                      id: layerId,
                      type: "line",
                      source: sourceId,
                      paint: {
                        "line-color": circleColors[radius],
                        "line-width": 3,
                      },
                      layout: {
                        visibility: activeRadius.includes(radius)
                          ? "visible"
                          : "none",
                      },
                    });
                    layersRef.current.push(layerId);
                  }
                });
              }
            });
          });
        }

        if (userGeoCords.lng && userGeoCords.lat && map.current) {
          if (TyphonCoords.length > 0) {
            const allTablesHTML = `
      <div id="all-storm-tables">
        ${TyphonCoords.map((main_datas: any[], main_index: number) => {
          if (!Array.isArray(main_datas) || main_datas.length === 0) {
            return "";
          }

          const stormName =
            trackDatas[main_index]?.storm_name || `Storm ${main_index + 1}`;
          const tableHeader = [
            "Index",
            "Storm Date Time (UTC)",
            "Position",
            "Distance (nm)",
            "System Speed (kn)",
            "Direction",
            "Pressure (hPa)",
            "Max Wind (kn)",
            "34-knot radius",
            "50-knot radius",
            "64-knot radius",
            "80-knot radius",
          ];

          return `
          <div class="storm-table-container" style="margin-bottom: 20px;">
            <h3>${stormName}</h3>
            <div class="popup-table right-popup">
              <table>
                <thead>
                  <tr>
                  ${tableHeader
                    .map((head) => `<td><strong>${head}</strong></td>`)
                    .join("")}
                  </tr>
                </thead>
                <tbody>
                ${main_datas
                  .slice()
                  .reverse()
                  .map((typhoon: any, idx: number) => {
                    const distanceToUser = Math.round(
                      Math.round(
                        (Math.floor(
                          calculateDistanceNauticalMiles(
                            parseFloat(userGeoCords.lat),
                            parseFloat(userGeoCords.lng),
                            parseFloat(typhoon.latlng[1]),
                            parseFloat(typhoon.latlng[0]),
                          ) * 100,
                        ) /
                          100) *
                          2,
                      ) / 2,
                    );
                    const correspondingTyphoon = typhoon;
                    let formattedDate = "-";
                    const qk = getQuadrantKey(
                      correspondingTyphoon.lat,
                      correspondingTyphoon.lon,
                      parseFloat(userGeoCords.lat),
                      parseFloat(userGeoCords.lng),
                    );
                    if (correspondingTyphoon.date_utc) {
                      try {
                        const utcDate = new Date(
                          correspondingTyphoon.date_utc + "Z",
                        );
                        const day = utcDate
                          .getUTCDate()
                          .toString()
                          .padStart(2, "0");
                        const time = `${utcDate
                          .getUTCHours()
                          .toString()
                          .padStart(2, "0")}:${utcDate
                          .getUTCMinutes()
                          .toString()
                          .padStart(2, "0")}`;
                        formattedDate = `${day}/${time}`;
                      } catch (e) {
                        console.warn("Date formatting error:", e);
                      }
                    }
                    return `
<tr>
<td>${idx + 1}</td>
<td>${formattedDate}</td>
<td>${Math.round((correspondingTyphoon.lat || 0) * 10) / 10}N ${
                      Math.round((correspondingTyphoon.lon || 0) * 10) / 10
                    }E</td>
<td>${distanceToUser}</td>
<td>${(correspondingTyphoon.speed_kts || 0).toFixed(2)}</td>
<td>${correspondingTyphoon.direction || "-"}</td>
<td>${correspondingTyphoon.central_pressure || "-"}</td>
<td>${correspondingTyphoon.max_wind_speed || "-"}</td>
<td>${correspondingTyphoon[`kts_34_${qk}`] || "-"}</td>
<td>${correspondingTyphoon[`kts_50_${qk}`] || "-"}</td>
<td>${correspondingTyphoon[`kts_64_${qk}`] || "-"}</td>
<td>${correspondingTyphoon[`kts_80_${qk}`] || "-"}</td>
</tr>`;
                  })
                  .join("")}
                </tbody>
              </table>
            </div>
          </div>`;
        }).join("")}
      </div>`;

            const userMarker = new mapboxgl.Marker({
              color: "#0077FF",
            }).setLngLat([
              parseFloat(userGeoCords.lng),
              parseFloat(userGeoCords.lat),
            ]);

            // Add click event for table popup (don't close existing popups)
            userMarker.getElement().addEventListener("click", (e) => {
              e.stopPropagation();

              // Only remove table popups, not the project label
              const existingTablePopups =
                document.querySelectorAll(".popup-main-table");
              existingTablePopups.forEach((popup) => popup.remove());

              new mapboxgl.Popup({
                offset: 25,
                maxWidth: "fit-content",
                anchor: "bottom-left",
                className: "popup-main-table",
                closeButton: true,
                closeOnClick: false,
              })
                .setHTML(allTablesHTML)
                .setLngLat([
                  parseFloat(userGeoCords.lng),
                  parseFloat(userGeoCords.lat),
                ])
                .addTo(map.current!);
            });

            userMarker.addTo(map.current);
            markersRef.current.push(userMarker);

            if (!document.getElementById("storm-table-styles")) {
              const style = document.createElement("style");
              style.id = "storm-table-styles";
              style.innerHTML = `
        #all-storm-tables {
          max-height: 500px;
          overflow-y: auto;
        }
        .storm-table-container {
          margin-bottom: 20px;
          border-bottom: 1px solid #ddd;
          padding-bottom: 10px;
        }
        .storm-table-container h3 {
          margin: 5px 0;
          font-weight: bold;
        }
      `;
              document.head.appendChild(style);
            }
          } else {
            const userMarker = new mapboxgl.Marker({
              color: "#0077FF",
            }).setLngLat([
              parseFloat(userGeoCords.lng),
              parseFloat(userGeoCords.lat),
            ]);

            userMarker.addTo(map.current);
            markersRef.current.push(userMarker);
          }

          // Create permanent project label popup (separate from table popup)
          let project = localStorage.getItem("project");
          const trimmedProject = project
            ? (project.match(/^(.*?)(?:\s*-\s*\w*\d[\d-]*)$/)?.[1]?.trim() ??
              project)
            : "";

          const projectLabelPopup = new mapboxgl.Popup({
            offset: 35,
            closeButton: false,
            closeOnClick: false,
            className: "project-label-popup", // Add unique class
          })
            .setHTML(`<b>${trimmedProject}</b>`)
            .setLngLat([
              parseFloat(userGeoCords.lng),
              parseFloat(userGeoCords.lat),
            ])
            .addTo(map.current);

          const popupContainer = (projectLabelPopup as any)._content;
          if (popupContainer) {
            popupContainer.style.backgroundColor = "rgba(0, 0, 0, 0)";
          }

          if (!document.getElementById("storm-table-styles")) {
            const style = document.createElement("style");
            style.id = "storm-table-styles";
            style.innerHTML = `
      #all-storm-tables {
        max-height: 500px;
        overflow-y: auto;
      }
      .storm-table-container {
        margin-bottom: 20px;
        border-bottom: 1px solid #ddd;
        padding-bottom: 10px;
      }
      .storm-table-container h3 {
        margin: 5px 0;
        font-weight: bold;
      }
      .mapboxgl-popup {
        pointer-events: auto;
      }
      .mapboxgl-popup-content {
        max-width: 400px;
        max-height: 300px;
        overflow: auto;
      }
      .popup-main-table .mapboxgl-popup-content {
        padding: 15px;
        max-width: 800px;
        max-height: 400px;
        overflow: auto;
      }
    `;
            document.head.appendChild(style);
          }
        }
      } catch (error) {
        console.error("Error adding map features:", error);
        setApiError(
          error instanceof Error ? error.message : "Error adding map features",
        );
      }
    }, 1000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [
    isStyleLoaded,
    fetchedDatas,
    stormDatas,
    TyphonCoords,
    userGeoCords,
    trackDatas,
    dataLoaded,
    mapDataLoaded,
  ]);

  const downloadPDFs = async (stormName: any) => {
    setLoading((prevLoading) => ({ ...prevLoading, [stormName]: true }));
    try {
      const project = localStorage.getItem("project");
      if (!project) {
        alert("No project found in website");
        setLoading((prevLoading: any) => ({
          ...prevLoading,
          [stormName]: false,
        }));
        return;
      }
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_IP}/api/downloadpdfthyphoon/`,
        { storm_name: stormName, project: project },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          responseType: "blob",
        },
      );
      if (response.status === 200 && response.data) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `TC_BULLETIN_${stormName}-${project}.pdf`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        alert(`No PDF file found for ${stormName} and project ${project}`);
      }
    } catch (error) {
      alert(`No PDF file found for ${stormName}`);
    } finally {
      setLoading((prevLoading: any) => ({
        ...prevLoading,
        [stormName]: false,
      }));
    }
  };

  useEffect(() => {
    const checkPdfAvailability = async () => {
      if (!Array.isArray(trackDatas) || trackDatas.length === 0) {
        return;
      }

      const project = localStorage.getItem("project") || "Project";
      for (const track of trackDatas) {
        if (!track?.storm_name) continue;

        try {
          const formData = new URLSearchParams();
          formData.append("storm_name", track.storm_name);
          formData.append("project", project);
          formData.append("check_only", "true");
          const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_IP}/api/downloadpdfthyphoon/`,
            formData,
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
              timeout: 10000,
            },
          );
          setPdfAvailability((prev) => ({
            ...prev,
            [track.storm_name]: response.status === 200,
          }));
        } catch (error) {
          setPdfAvailability((prev) => ({
            ...prev,
            [track.storm_name]: false,
          }));
        }
      }
    };

    checkPdfAvailability();
  }, [trackDatas]);

  useEffect(() => {
    return () => {
      try {
        cleanupMapFeatures();
        if (map.current) {
          map.current.remove();
          map.current = null;
        }
      } catch (error) {
        console.warn("Error during component cleanup:", error);
      }
    };
  }, []);

  const handleIndividualToggle = (selectedRadius: string) => {
    if (activeRadius.includes(selectedRadius)) {
      const newActiveRadius = activeRadius.filter(
        (radius) => radius !== selectedRadius,
      );
      setActiveRadius(newActiveRadius);
    } else {
      const newActiveRadius = [...activeRadius, selectedRadius];
      setActiveRadius(newActiveRadius);
    }
  };

  return (
    <div className={open ? "sideNavOpen" : "sideNavClose"}>
      <div className="sidebar">
        <div className={["sidebar-mode", "icon-menu"].join(" ")}>
          <button
            onClick={() => {
              if (popupbar.current !== null) {
              }
            }}
            className="mode-button"
          ></button>
          <button
            onClick={() => {
              if (popupbar.current !== null) {
              }
            }}
            className="mode-button"
          ></button>
        </div>

        <div className="wind-radii-panel">
          <div className="panel-title">Wind Radii</div>
          <div className="title-divider"></div>

          {circleRadius.slice(0, 4).map((circle) => {
            const isActive = activeRadius.includes(circle);
            const radiusLabels: { [key: string]: string } = {
              kts_34_ne: "34 Knots",
              kts_50_ne: "50 Knots",
              kts_64_ne: "64 Knots",
              kts_80_ne: "80 Knots",
            };
            const labelColors: { [key: string]: string } = {
              kts_34_ne: "green",
              kts_50_ne: "yellow",
              kts_64_ne: "red",
              kts_80_ne: "black",
            };

            return (
              <div key={circle} className="control-row">
                <div
                  className="wind-speed-label"
                  style={{ color: labelColors[circle] }}
                >
                  {radiusLabels[circle]}
                </div>
                <div
                  className={`toggle-switch ${
                    isActive ? "active" : ""
                  } toggle-${circle}`}
                  onClick={() => handleIndividualToggle(circle)}
                >
                  <div className="toggle-indicator"></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div ref={popupbar} className="bottom-bar-popup">
        {Array.isArray(trackDatas) &&
          trackDatas.map((data: any, index: number) => {
            if (!data?.storm_track_id || !data?.storm_name) return null;

            const exactKey = `storm_${data.storm_track_id}`;
            const hasMapHoverMatch =
              mapHovers[exactKey] !== undefined &&
              mapHovers[exactKey].lon !== undefined;
            const hasStormData =
              index < TyphonCoords.length &&
              Array.isArray(TyphonCoords[index]) &&
              TyphonCoords[index].length > 0;
            const shouldShow = hasMapHoverMatch || hasStormData;

            return shouldShow ? (
              <span key={data.storm_track_id} className="bottom-bar-box">
                <span
                  onClick={() => {
                    if (map.current === null) return;

                    if (hasMapHoverMatch) {
                      map.current.setCenter([
                        mapHovers[exactKey].lon,
                        mapHovers[exactKey].lat,
                      ]);
                    } else if (hasStormData) {
                      const latestStormPosition = TyphonCoords[index][0];
                      if (latestStormPosition?.latlng) {
                        map.current.setCenter([
                          latestStormPosition.latlng[0],
                          latestStormPosition.latlng[1],
                        ]);
                      }
                    }
                  }}
                >
                  {data.storm_name}
                </span>
                {/* <Button
                  variant="contained"
                  color={pdfAvailability[data.storm_name] ? "error" : "success"}
                  onClick={() => downloadPDFs(data.storm_name)}
                  disabled={loading[data.storm_name]}
                  startIcon={
                    loading[data.storm_name] ? (
                      <CircularProgress size={20} />
                    ) : null
                  }
                >
                  last issued PDF
                </Button> */}
                {pdfAvailability[data.storm_name] && (
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => downloadPDFs(data.storm_name)}
                    disabled={loading[data.storm_name]}
                    startIcon={
                      loading[data.storm_name] ? (
                        <CircularProgress size={20} />
                      ) : null
                    }
                  >
                    last issued PDF
                  </Button>
                )}
              </span>
            ) : null;
          })}
      </div>

      {(!dataLoaded || !mapDataLoaded) && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            zIndex: 1000,
            padding: "20px",
            borderRadius: "8px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "10px",
            maxWidth: "300px",
            textAlign: "center",
          }}
        >
          <Loder />
        </div>
      )}

      {hoverCoords && (
        <div className="map-coordinates-display">
          <div className="coord-label">
            Lat: {hoverCoords.lat.toFixed(5)}, Lon: {hoverCoords.lng.toFixed(5)}
          </div>
        </div>
      )}

      <div ref={mapContainer} className="map-container" />
    </div>
  );
}
